import type { TradeTabProps } from '../../../../types/LayoutConfig';
import { DEFAULT_TRADE_TABS } from '../../../Blotters/Trades/defaults';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile trades content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileTradesBlotter(props: Omit<MobileBlotterPanelProps<TradeTabProps>, 'defaultTabs'>) {
  return <MobileBlotterPanel<TradeTabProps> {...props} defaultTabs={DEFAULT_TRADE_TABS} />;
}
